export class SingleHolydaysExclusionCheckValidator {
  type: 'single_holydays_exclusion';

  attribute_id: string;
}
